import { render, staticRenderFns } from "./ParagraphRenderer.vue?vue&type=template&id=bd3adf68&"
import script from "./ParagraphRenderer.vue?vue&type=script&lang=js&"
export * from "./ParagraphRenderer.vue?vue&type=script&lang=js&"
import style0 from "./ParagraphRenderer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports